<template>
	<div
		:class="['job-results--item', {'loading-blockade': loadingItem}]"
		v-inview:enter="comesToViewport"
		v-inview:leave="leavesViewport"
	>
		<a
			v-if="localItem"
			href="#"
			class="job-results--item--title"
			@click.prevent="onItemClick"
		>
			{{ listingItem.name }}
			<span v-if="externalCustomer || !seen" class="job-results--item--title-badges">
				<span v-if="externalCustomer" v-b-tooltip :title="externalCustomerHint">Jobvermittler</span>
				<span v-if="!seen" class="job-results--item--title-badge-new">Neu</span>
			</span>
		</a>
		<div>
			<div v-if="loadingMatching" class="job-results--item--loading-placeholder">
				<div>&nbsp;</div>
			</div>
			<template v-else-if="matching">
				<div class="matching narrow-label">
					<div class="matching--category matching--category--no-y-padding">
						<div class="matching--category-items matching--category-items-no-item-x-padding">
							<MatchingItem
								v-for="item in matchingItems"
								:key="item.id"
								:label="item.label"
								:score="item.score"
								:max-score="item.maxScore"
								:with-percentage="false"
								:info-text="item.infoText"
								clickable
								vertical-align-center
								@click="onItemClick"
							/>
						</div>
					</div>
				</div>
				<div v-if="localItem" class="job-list-item-infos">
					<div v-if="localItem.disclosedData" class="job-list-item-infos-info">
						<div>Firma</div>
						<div>
							{{ localItem.disclosedData.companyName }}
							({{ localItem.disclosedData.contactPerson }})
						</div>
					</div>
					<div class="job-list-item-infos-info" :title="placesOfWork">
						<div>{{ listingItem.placesOfWork.length > 1 ? 'Orte' : 'Ort' }}</div>
						<div>{{ maxLength(placesOfWork, 35) }}</div>
					</div>
					<div class="job-list-item-infos-info" :title="industrialSectors">
						<div>{{ listingItem.industrialSectors.length > 1 ? 'Branchen' : 'Branche' }}</div>
						<div>{{ maxLength(industrialSectors, 35) }}</div>
					</div>
				</div>
				<div v-if="localItem" class="job-list-item-actions">
					<template v-if="!exclusion">
						<Button
							v-if="isPublished && !localItem.communication.hasOngoingConversation"
							text="Anonym kontaktieren"
							secondary
							class="mr-2"
							@click="contactNow"
						/>
						<a
							v-if="isPublished && messagesCount > 0"
							href="#"
							class="action turquoise"
							@click.prevent="clickedMessages"
						>
							<Icon icon="mail"/>
							<span v-if="newMessagesCount > 0" class="count-bubble">{{ newMessagesCount }}</span>
						</a>

						<a
							v-if="isPublished && hasAppointments"
							href="#"
							class="action lime"
							@click.prevent="clickedCalendar"
						>
							<Icon icon="calendar"/>
							<span class="count-bubble">{{ appointmentsCount }}</span>
						</a>

						<Favorite
							v-if="!exclusion"
							:job-profile-id="listingItem.id"
							:job-id="job.id"
							:initial-favored="favored"
							type="application"
							@change="favored = $event"
						/>
						<Notice
							v-if="!exclusion"
							:job-profile-id="listingItem.id"
							:notice="notice"
							type="application"
							:sub-title="listingItem.name"
							@change="notice = $event"
						/>
					</template>
					<Exclusion
						:job-profile-item="listingItem"
						:job-id="job.id"
						:exclusion="exclusion"
						@change="onExclusionChange"
					/>
					<template v-if="!exclusion">
						<a href="#" class="action no-icon" @click.prevent="openMatchingFan">
							Mehr Infos
							<Icon icon="caret-right"/>
						</a>
					</template>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import Matching from "@/api/job/Matching";
import Loading from "@/vue/common/Loading";
import MatchingItem from "@/vue/common/matching/Item"
import Notice from "@/vue/job-result/notice/Notice";
import Favorite from "@/vue/customer/job-profile/applicant/Favorite";
import Rating from "@/vue/customer/job-profile/applicant/Rating";
import Exclusion from "@/vue/application/job/exclusion/Exclusion";
import IconLink from "@/vue/common/IconLink";
import Icon from "@/vue/icon/Icon"
import {PUBLISHED} from "@/helper/job/Status";
import {mapActions} from "vuex";
import {getDefaultItems} from "@/helper/job/Matching";
import {INITIATOR_APPLICANT} from "@/store/communication/conversation/messages";
import {LIST_TYPE__APPLICANT} from "@/store/communication/appointment";
import Listing from "@/api/job/Listing";
import AsyncQueue from "@/helper/async-queue/AsyncQueue";
import {maxLength} from "@/helper/String";
import Button from "@/vue/common/Button";
import * as Event from "@/helper/tracking/Event";
import EventData from "@/helper/tracking/EventData";
import EventBus from "@/event/EventBus";
import {MESSAGE_FAN_CLOSED} from "@/event/Event";

export default {

	components: {
		Icon,
		IconLink,
		MatchingItem,
		Notice,
		Loading,
		Favorite,
		Rating,
		Exclusion,
		Button,
	},

	props: {
		job: {
			type: Object,
			required: true,
		},
		item: {
			type: Object,
			required: true,
		},
	},

	mounted ()
	{
		this.messageFanClosedHandler = ({jobId}) =>
		{
			if (jobId === this.job.id)
			{
				this.reloadItem();
			}
		};

		EventBus.$on(MESSAGE_FAN_CLOSED, this.messageFanClosedHandler);
	},

	beforeDestroy ()
	{
		EventBus.$off(MESSAGE_FAN_CLOSED, this.messageFanClosedHandler);
	},

	data ()
	{
		return {
			localItem: this.item,
			loadedMatching: false,
			loadingMatching: true,
			matching: null,
			favored: this.item.listingItem.favored,
			notice: this.item.listingItem.notice,
			exclusion: this.item.listingItem.exclusion,
			externalCustomer: this.item.listingItem.externalCustomer,
			seen: this.item.listingItem.seen,
			loadingItem: false,
			messageFanClosedHandler: undefined,
		};
	},

	computed: {
		externalCustomerHint ()
		{
			return 'Das ist ein Job eines Personalvermittlers, der für eine andere Organisation MitarbeiterInnen sucht.';
		},
		isPublished ()
		{
			return this.job.status === PUBLISHED;
		},
		messagesCount ()
		{
			return this.localItem.communication.messagesCount;
		},
		newMessagesCount ()
		{
			return this.localItem.communication.newMessagesCount;
		},
		appointmentsCount ()
		{
			return this.localItem.communication.appointmentsCount;
		},
		hasAppointments ()
		{
			return this.appointmentsCount > 0;
		},
		listingItem ()
		{
			return this.localItem.listingItem;
		},
		matchingItems ()
		{
			return getDefaultItems(this.matching);
		},
		placesOfWork ()
		{
			return this.listingItem.placesOfWork.join(', ');
		},
		industrialSectors ()
		{
			return this.listingItem.industrialSectors.join(', ');
		},
	},

	methods: {
		...mapActions('job/matching', {
			showMatching: 'show'
		}),
		...mapActions('communication/conversation/messages', {
			openMessagesFan: 'show',
		}),
		...mapActions('communication/appointment', {
			openAppointmentFan: 'show',
		}),
		...mapActions('communication/contactJobProfile', {
			openContactingFan: 'show'
		}),
		maxLength (text, length)
		{
			return maxLength(text, length);
		},
		onExclusionChange (exclusion)
		{
			if (exclusion)
			{
				this.$emit('addExclusion');
			}
			else
			{
				this.$emit('removeExclusion');
			}
		},
		clickedMessages ()
		{
			this.openMessagesFan({
				applicantData: {
					job: this.job,
					jobProfile: this.listingItem,
				},
				initiator: INITIATOR_APPLICANT,
				onClose: () =>
				{
					this.$emit('messagesClosed');

					this.reloadItem();
				}
			});
		},
		clickedCalendar ()
		{
			this.openAppointmentFan({
				listType: LIST_TYPE__APPLICANT,
				jobId: this.job.id,
				jobProfileId: this.listingItem.id,
				onClose: () =>
				{
					this.reloadItem();
				}
			});
		},
		onItemClick ()
		{
			this.seen = true;

			this.openMatchingFan();
		},
		contactNow ()
		{
			this.seen = true;

			Event.push(
				new EventData()
					.setEvent(Event.APPLICANT_JOB)
					.setAction('Anonym kontaktieren (Fächer-Öffnung)')
					.setName(this.listingItem.name)
			);

			this.openContactingFan({
				jobId: this.job.id,
				jobProfileId: this.listingItem.id,
				jobProfileName: this.listingItem.name,
				onContacted: () =>
				{
					this.reloadItem();
				}
			});
		},
		openMatchingFan ()
		{
			Event.push(
				new EventData()
					.setEvent(Event.APPLICANT_JOB)
					.setAction('Jobprofil öffnen')
					.setName(this.listingItem.name)
			);

			this.showMatching({
				job: this.job,
				jobProfile: this.listingItem,
				hasOngoingConversation: this.localItem.communication.hasOngoingConversation,
				favored: this.favored,
				notice: this.notice,
				exclusion: this.exclusion,
				withActions: true,
				onContacted: () =>
				{
					this.reloadItem();
				},
				onFavoriteChange: (favored) =>
				{
					this.favored = favored;
				},
				onNoticeChange: (notice) =>
				{
					this.notice = notice;
				},
				onExclusionChange: (exclusion) =>
				{
					this.exclusion = exclusion;

					this.onExclusionChange(exclusion);
				},
			});
		},
		leavesViewport ()
		{
			// see documentation beneath why we are doing this
			if (this.loadMatchingTimeout)
			{
				clearTimeout(this.loadMatchingTimeout);

				this.loadMatchingTimeout = undefined;
			}
		},
		comesToViewport ()
		{
			if (this.loadedMatching)
			{
				return;
			}

			// wait 1 second to load matching, maybe user is scrolling fast by. in this case we do not want to have
			// a lot of parallel matching requests
			this.loadMatchingTimeout = setTimeout(async () =>
			{
				this.loadedMatching = true;

				AsyncQueue.addProcess({
					execute: () =>
					{
						return new Matching()
							.setJob(this.job.id)
							.setJobProfile(this.listingItem.id)
							.setSkipVita(true)
							.call();
					},
					onFinish: ({result}) =>
					{
						this.matching = result.data.matching;

						this.loadingMatching = false;
					}
				});

			}, 1000);
		},
		async reloadItem ()
		{
			if (!this.loadedMatching)
			{
				return;
			}

			AsyncQueue.addProcess({
				execute: () =>
				{
					this.loadingItem = true;

					return new Listing()
						.setJob(this.job.id)
						.setJobProfile(this.item.listingItem.id)
						.call();
				},
				onFinish: ({result}) =>
				{
					const items = result.data.items;

					// could be out now because of sent off
					if (items.length === 0)
					{
						this.$emit('remove');
					}
					else
					{
						const item = _.first(result.data.items);

						// force actions remount
						this.localItem = undefined;

						this.favored = item.listingItem.favored;
						this.notice = item.listingItem.notice;
						this.exclusion = item.listingItem.exclusion;

						this.$nextTick(() => this.localItem = item);
					}

					this.loadingItem = false;
				}
			});
		}
	},
}
</script>
